module.exports = __webpack_public_path__ + "static/pixel-phone-373ee85d14bcfdc055cf9340cec16d67.png";